export enum ProfileType {
  Own = 'own',
  External = 'external',
}

export enum ProfileStatus {
  Active = 'active',
  Archive = 'archived',
}

export enum ProfileCardType {
  All = 'all',
  User = 'user',
  Guest = 'guest',
  Archive = 'archive',
}

export interface ProfileCard {
  id: number
  name: string
  countryCode: string
  balanceAmount: number
  comment?: string
  ownerPhone: string
  profileType: ProfileType
  status: ProfileStatus
  linkAuth: string
  archivedAt: string
  permissionRole: string
  isIdentified?: boolean
}

export interface GetUserInfoData {
  name: string
  email: string
}

export interface AddProfileCardData {
  name: string
  comment?: string
  country_code: string
}

export interface UpdateProfileCardData {
  name?: string
  comment?: string
}

export interface RedirectResponse {
  data: {
    redirect_url: string
  }
}
